import { render } from "./OnDayProcess.vue?vue&type=template&id=149693b5&ts=true"
import script from "./OnDayProcess.vue?vue&type=script&lang=ts"
export * from "./OnDayProcess.vue?vue&type=script&lang=ts"

import "./OnDayProcess.vue?vue&type=style&index=0&id=149693b5&lang=css"

import exportComponent from "/home/runner/work/ch-ocean-widget/ch-ocean-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__